import WidgetModule from "@eisinc/Overrides/Widgets/OrderConfirmation/OrderConfirmationShippingInformation";

export * from "@eisinc/Overrides/Widgets/OrderConfirmation/OrderConfirmationShippingInformation";

export default WidgetModule;
